import axios from 'axios'

import i18next from 'i18next'
import {
  decrementLoader,
  handleError,
  incrementLoader,
  resetLoader,
  updateError,
} from '../store/actions/drawer.actions'
import { store } from './configureStore'
import { goToLoginPage } from 'utils'

export default function httpMiddleware() {
  axios.interceptors.request.use(
    (request) => {
      store.dispatch(incrementLoader())
      return request
    },
    (asyncError) => {
      store.dispatch(updateError(asyncError))
      store.dispatch(resetLoader())
      return Promise.reject(asyncError)
    }
  )

  axios.interceptors.response.use(
    (response) => {
      setTimeout(() => {
        store.dispatch(decrementLoader())
      }, 0)
      return response
    },
    (asyncError) => {
      const { data, status } = asyncError.response || {}
      const { loggedIn } = data || {}

      if (status === 423 || status === 403) {
        store.dispatch(updateError(asyncError))
        store.dispatch(
          handleError({
            goToLogin: () => goToLoginPage({ language: i18next.language }),
            loggedIn,
            status,
          })
        )
      }
      store.dispatch(resetLoader())
      return Promise.reject(asyncError)
    }
  )
}
